import React from 'react';
import { AddEditOrder } from './AddEditOrder';

const addEditOrderRoutes = [
	{
		props: {
			exact: true,
			path: `/menu/outlet-app/:outletID/table/grid/:tableID/order/:orderID/add-edit-order`,
		},
		component: <AddEditOrder />,
	},
];

export default addEditOrderRoutes;
